import Quill from 'quill';

let registered = false;

/** Registra quill-mention (blot + módulo) en el mismo Quill que usa PrimeNG. */
export async function registerQuillMention(): Promise<void> {
  if (registered) return;
  const QuillCtor = (await import('quill')).default;
  const { MentionBlot, Mention } = await import('quill-mention');
  QuillCtor.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });
  registered = true;
}

export type QuillEditorInstance = InstanceType<typeof Quill>;
